<script setup lang="ts">
// Shown to users on the no-card Pro trial (subscriptionStatus === 'trialing').
// Client-only (wrapped in <ClientOnly> by the layout) so the day countdown never
// causes an SSR hydration mismatch.
const { t } = useI18n();
const { isTrialing, trialEndsAt } = useEntitlements();
const { openModal } = useBillingModal();
const { isUae } = useUaeGate();

const daysLeft = computed(() => {
  if (!trialEndsAt.value) return 0;
  const ms = new Date(trialEndsAt.value).getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)));
});

const label = computed(() => {
  const d = daysLeft.value;
  if (d <= 0) return t('shell.trialBanner.ended');
  return t('shell.trialBanner.daysLeft', { count: d }, d);
});
</script>

<template>
  <div
    v-if="isTrialing && trialEndsAt && !isUae"
    class="mb-5 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-gold-primary-120/30 bg-gold-primary-120/[0.08] px-4 py-3 tablet:px-5"
  >
    <div class="flex items-center gap-2 text-[13px] font-semibold text-black-100">
      <span aria-hidden="true">🎁</span>
      <span>{{ label }}</span>
    </div>
    <button
      type="button"
      class="h-9 shrink-0 rounded-full bg-gold-primary-120 px-5 text-[12px] font-bold text-white transition-colors hover:bg-gold-primary-100"
      @click="openModal()"
    >
      {{ t('shell.trialBanner.subscribeButton') }}
    </button>
  </div>
</template>
